export * from './tab-content.directive';
